import gql from 'graphql-tag';

/** Elenco delle evidenze di un Good360 (per la sezione "Evidenza prodotto"). */
export const Good360EvidencesQuery = gql`
	query Good360EvidencesQuery($id: ID!) {
		entity: node(id: $id) {
			id
			... on Good360 {
				evidences {
					id
					localId
					type
					startDate
					endDate
				}
			}
		}
	}
`;
